"use strict";

import { dateFormat } from "@/utils/dateFormat.js";
import store from "@/store";
var OSS = require("ali-oss");

export default {
  /**
   * 创建随机字符串
   * @param num
   * @returns {string}
   */
  randomString(num) {
    let chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ];
    let res = "";
    for (let i = 0; i < num; i++) {
      var id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    return res;
  },

  /**
   * 创建oss客户端对象
   * @returns {*}
   */
  createOssClient() {
    return new Promise((resolve) => {
      let client = new OSS({
        region: "oss-cn-shanghai",
        accessKeyId: "LTAI8kfsxSv2G7sq",
        accessKeySecret: "xaJOAfa31a2CzTVw4WfOy5hhXQnaSg",
        bucket: "ntppc",
        // callback: {
        //     url: "http://oss-demo.aliyuncs.com:23450",
        //     host: "oss-cn-hangzhou.aliyuncs.com",
        //     /* eslint no-template-curly-in-string: [0] */
        //     body: "bucket=${bucket}&object=${object}&var1=${x:var1}",
        //     contentType: "application/x-www-form-urlencoded",
        //     customValue: {
        //       var1: "value1",
        //       var2: "value2"
        //     }
        // }
      });
      resolve(client);
    });
  },
  /**
   * 文件上传
   * @param option 参考csdn: https://blog.csdn.net/qq_27626333/article/details/81463139
   */
  ossUploadFile(option) {
    let file = option.file;
    const self = this;
    return new Promise((resolve, reject) => {
      let date = dateFormat(new Date(), "yyyyMMdd"); // 当前时间
      // let dateTime = dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
      let randomStr = self.randomString(4); //  4位随机字符串
      // let extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
      let fileName = "mp4/" + date + randomStr + "/" + file.name; // 文件名字（相对于根目录的路径 + 文件名）
      // 执行上传
      self.createOssClient().then((client) => {
        // 异步上传,返回数据
        // resolve({
        //   fileName: file.name,
        //   fileUrl: fileName
        // });
        // 上传处理
        // 分片上传文件
        client
          .multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {};
              e.percent = Math.floor(p * 100);

              option.onProgress(e);
            },
            meta: { year: 2020, people: "test" },
          })
          .then(
            (val, p) => {
              if (val.res.statusCode === 200) {
                console.log(p, "pppp");
                option.onSuccess(val);
                console.log(val, "val");
                resolve({
                  fileName: file.name,
                  fileUrl: fileName,
                });
                return val;
              } else {
                option.onError("上传失败");
              }
            },
            (err) => {
              option.onError("上传失败");
              reject(err);
            }
          );
      });
    });
  },
  // 图片上传
  ossUploadImg(option) {
    let file = option.file;
    const self = this;
    return new Promise((resolve, reject) => {
      let date = dateFormat(new Date(), "yyyyMMdd"); // 当前时间
      let randomStr = self.randomString(4); //  4位随机字符串
      let extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
      let fileName = "train-img/" + date + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）

      self.createOssClient().then((client) => {
        client
          .put(fileName, file)
          .then((res) => {
            if (res.res.statusCode === 200) {
              if (!store.state.app.isMobile) {
                option.onSuccess(res);
              }
              resolve({
                fileName: file.name,
                fileUrl: fileName,
                uid: file.uid,
              });
            } else {
              option.onError("上传失败");
            }
          })
          .catch((e) => {
            option.onError("上传失败");
            reject(e);
          });
      });
    });
  },
};
